import { Container, Typography, Box, Link } from "@mui/material"

import PageLayout from "../../layouts/PageLayout"
import PageHeader from "../../components/PageHeader"
import { EMAIL, EMAIL_HREF, PHONE_DISPLAY, PHONE_HREF } from "../../constants/contactInfo"
import { OFFICE_ADDRESS } from "../../constants/address"

const PrivacyPolicy = () => (
    <PageLayout
        hero={
            <PageHeader
                title="Privacy Policy"
                subtitle="How Clerk Solutions Limited (trading as Stargate Rentals) collects and uses your information"
            />
        }
    >
        <Box component="section" sx={{ py: 5 }}>
            <Container maxWidth="md" sx={{ mt: 2.5 }}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Clerk Solutions Limited Privacy Policy
                </Typography>
                <Typography variant="subtitle1" mb={3} color="text.secondary">
                    Effective Date: 1 February 2024 · Last updated: 13 July 2026
                </Typography>

                <Typography variant="body1" paragraph>
                    Clerk Solutions Limited (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;), trading
                    as Stargate Rentals, is the data controller for personal information collected
                    through this website and related enquiries about Private Hire vehicle hire.
                </Typography>

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    1. Information we collect
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>Personal information</strong> you provide when you enquire, contact us,
                    or enter a hire arrangement — for example your name, phone number, email
                    address, and details about your Private Hire licensing or preferred vehicle.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>Technical information</strong> collected automatically when you use the
                    site — such as browser type, device, approximate location derived from IP
                    address, and pages visited — via cookies and similar technologies where
                    enabled.
                </Typography>

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    2. How we use your information
                </Typography>
                <Typography variant="body1" paragraph>
                    We use your information to respond to enquiries, arrange vehicle hire and
                    collections, manage customer relationships, improve our website and services,
                    and meet legal or regulatory obligations.
                </Typography>

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    3. Cookies and similar technologies
                </Typography>
                <Typography variant="body1" paragraph>
                    We may use cookies and similar technologies to understand how the site is used
                    and to improve your experience. You can manage cookie preferences through your
                    browser settings. Blocking some cookies may affect site functionality.
                </Typography>

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    4. Sharing your information
                </Typography>
                <Typography variant="body1" paragraph>
                    We do not sell your personal information. We may share it with service providers
                    who help us operate our business (for example hosting, email, or messaging), or
                    when required by law. Where third-party tools are used on this site, their own
                    privacy policies also apply.
                </Typography>

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    5. Third-party links
                </Typography>
                <Typography variant="body1" paragraph>
                    Our website may link to third-party sites (for example maps or social media).
                    We are not responsible for the privacy practices or content of those sites.
                </Typography>

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    6. How long we keep information
                </Typography>
                <Typography variant="body1" paragraph>
                    We keep personal information only for as long as needed for the purposes above,
                    including any period required for hire agreements, accounting, or legal
                    obligations, after which it is deleted or anonymised where practicable.
                </Typography>

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    7. Your rights
                </Typography>
                <Typography variant="body1" paragraph>
                    Under UK data protection law you may have rights to access, correct, erase, or
                    restrict use of your personal information, and to object to certain processing.
                    To exercise these rights, contact us using the details below.
                </Typography>

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    8. Contact us
                </Typography>
                <Typography variant="body1" paragraph>
                    Questions about this Privacy Policy or your personal data can be sent to:
                </Typography>
                <Typography variant="body1" component="div" sx={{ mb: 1 }}>
                    Clerk Solutions Limited
                    <br />
                    Trading as Stargate Rentals
                    <br />
                    {OFFICE_ADDRESS}
                </Typography>
                <Typography variant="body1">
                    Email:{" "}
                    <Link href={EMAIL_HREF} underline="hover">
                        {EMAIL}
                    </Link>
                    <br />
                    Phone:{" "}
                    <Link href={PHONE_HREF} underline="hover">
                        {PHONE_DISPLAY}
                    </Link>
                </Typography>
            </Container>
        </Box>
    </PageLayout>
)

export default PrivacyPolicy
